<template>

</template>

<script>

    import api from './backend-api'
    import { useI18n } from 'vue-i18n'
    import { useStore } from 'vuex'

    export default {
        name: "RegistrationConfirm",
        setup() {
            const { t } = useI18n();
            const store = useStore();
            return { t, store };
        },
        data() {
            return {
                code: ''
            }
        },
        created() {
            this.code = this.$route.params.code;
            api.registrationConfirm(this.code)
                .then(response => {
                    if (response.data.success) {
                        this.store.commit('setMessage', response.data.message);
                        this.$router.push('/login').catch(error => {
                            console.log(error);
                        });
                    } else {
                        this.store.commit('setMessage', response.data.message);
                        this.$router.push('/registration').catch(error => {
                            console.log(error);
                        });
                    }
                })
                .catch(() => {
                    this.store.commit('setMessage', this.t('connectionLost'));
                    this.$router.push('/registration').catch(error => {
                        console.log(error);
                    });
                })
        }
    }
</script>

<style scoped>

</style>